/**
 * Pairing service – mapping body pairing_code sesuai spesifikasi.
 */

import { postWebosPair } from '../repository.js';
import { setToken } from './sessionService.js';

export async function pair(pairingCode, { persistToken = true } = {}) {
  const code = String(pairingCode || '').trim();
  const { ok, status, json } = await postWebosPair({ pairing_code: code });

  if (ok && json?.token) {
    if (persistToken) setToken(json.token);
    return { token: String(json.token), screen: json?.screen || null };
  }

  const errCode = json?.error || `HTTP_${status || 0}`;
  const message =
    json?.message ||
    json?.errorText ||
    (typeof json?.errors === 'string' ? json.errors : null) ||
    (status === 400 ? 'Permintaan tidak valid (400). Periksa kode pairing.' : 'Pairing failed');
  const e = new Error(message);
  e.code = errCode;
  e.status = status;
  e.payload = json;
  throw e;
}
